import { render, staticRenderFns } from "./hr-date-bill.vue?vue&type=template&id=70245dfd&"
import script from "./hr-date-bill.vue?vue&type=script&lang=js&"
export * from "./hr-date-bill.vue?vue&type=script&lang=js&"
import style0 from "./hr-date-bill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports